import { BaseButtons, BaseFeedbackConIcona, BaseGridLayout } from '@lucan/base-ui'
import { CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import { useAppContext } from 'GlobalContext'
import { MESSAGGIO_ERRORE_1, TORNA_ALLA_HOME_STRING } from 'strings/errori'
import useNavigate from 'utils/useNavigate'

export default function HomeErrore() {
  const { navigate } = useNavigate()

  const { uri } = useAppContext()

  return (
    <>
      <BaseGridLayout justifyCenter disposizioneRighe={[1, 1]}>
        <BaseFeedbackConIcona.Errore messaggio={MESSAGGIO_ERRORE_1} />

        <BaseButtons.Custom
          testo={TORNA_ALLA_HOME_STRING}
          onClick={() => navigate(CHIAVI_ROUTES.FRONTOFFICE)}
          hidden={!uri}
        />
      </BaseGridLayout>
    </>
  )
}